export enum BrandingType {
  CustomerPortal = 'customer-portal',
  Store = 'store',
  Email = 'email',
}
